import { BOOKING_POLICY } from "@/lib/policy";

export default function PolicyContent({ className = "" }) {
  return (
    <div data-testid="policy-content" className={`space-y-6 ${className}`}>
      {BOOKING_POLICY.map((sec) => (
        <div key={sec.title}>
          <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#C5B382] mb-2">{sec.title}</div>
          <ul className="space-y-1.5">
            {sec.items.map((t, i) => (
              <li key={i} className="text-sm text-[#1C1917]/70 leading-relaxed flex gap-2.5">
                <span className="text-[#C5B382] mt-1.5 h-1 w-1 rounded-full bg-[#C5B382] shrink-0" />
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
